import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
const refresh = () => (refreshing ||= axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; }));
http.interceptors.response.use(null, async (err) => {
  const cfg = err.config || {};
  if (err.response?.status === 401 && !cfg._retried && !cfg.url?.startsWith("/auth/")) {
    cfg._retried = true;
    try { await refresh(); return http(cfg); } catch { window.dispatchEvent(new Event("auth:expired")); }
  }
  return Promise.reject(err);
});
export const fileUrl = (path, download) =>
  path ? `${API}/files/${path}${download ? `?download=${encodeURIComponent(download)}` : ""}` : null;
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join("; ");
  return (typeof d === "string" && d) || e?.message || "Something went wrong";
};
export const sceneFile = (n) => `scene_${String(n).padStart(3, "0")}.mp4`;
export const safeName = (s) => (s || "file").replace(/[^A-Za-z0-9_-]/g, "_");
export const uploadFile = (path, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return http.post(path, fd);
};

export async function streamPost(path, body, onChunk, retried) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (res.status === 401 && !retried) {
    try { await refresh(); } catch { window.dispatchEvent(new Event("auth:expired")); throw new Error("Please sign in again"); }
    return streamPost(path, body, onChunk, true);
  }
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "Request failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      const line = ev.replace(/^data: /, "");
      if (!line.trim()) continue;
      const msg = JSON.parse(line);
      if (msg.error) throw new Error(msg.error);
      if (msg.t) onChunk(msg.t);
    }
  }
}
